import React from 'react'
import { Badge, BadgeArea, BaseButton, CardEventHeader, CarouselHeader, OpenEventsCard } from 'iebt-zing-storybook'
import { trans } from 'sharedKernel/i18n'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { Event } from 'data/contracts'
import { SwiperWrapper } from 'components/swiper'
import { removeTagsHTML } from 'sharedKernel/handlers'
import { DateTime } from 'luxon'  // já que no exemplo você usa DateTime

export interface HubStartupEventsCarouselListProps {
  eventList: Event[]
  totalScreenCards?: number
}

export const HubStartupEventsCarouselList = ({
  eventList,
  totalScreenCards = eventList.length,
  ...props
}: HubStartupEventsCarouselListProps): JSX.Element => {
  const navigate = useNavigate()

  const cards = eventList
    .slice(0, totalScreenCards)
    .map((event, index) => {
      const deadline = DateTime.fromISO(event.endDate || '').setLocale('pt').toLocaleString(DateTime.DATE_FULL)
      const buttons = (
        <BaseButton
            btnContent={'Ver Evento'}
            variant='risk-secondary'
            size='medium'
            onClick={() => navigate(`/hub/startup/event/${event.id}`)}
        />
      )

      return (
        <OpenEventsCard
          key={index}
          header={<CardEventHeader coverImage={event.style.coverImagePath} />}
          title={event.name}
          shortDescription={removeTagsHTML(event.description)}
          badges={
            <BadgeArea badgeQty={1}>
              <Badge
                text={trans('Prazo: ')}
                value={deadline}
                icon={['fas', 'calendar-day']}
                type="string"
              />
            </BadgeArea>
          }
          buttons={buttons}
        />
      )
    })

  const buildBreakpoints = (): any => ({
    350: { slidesPerView: 1, spaceBetween: 20 },
    900: { slidesPerView: 2, spaceBetween: 20 },
    1200: { slidesPerView: 3, spaceBetween: 20 },
    1500: { slidesPerView: 4, spaceBetween: 20 },
    1800: { slidesPerView: 5, spaceBetween: 20 },
    2200: { slidesPerView: 6, spaceBetween: 20 },
    2800: { slidesPerView: 7, spaceBetween: 20 }
  })

  return (
    <>
      <CarouselHeader
        title={trans('Eventos')}
        info={trans('Veja os eventos disponíveis')}
      />
      <SwiperWrapper
        breakpoints={buildBreakpoints()}
        carouselItems={cards}
        arrowColor="var(--primary)"
      />
    </>
  )
}
